import { useFormContext } from 'react-hook-form';
import ErrorMessage from './ErrorMessage';
import Details from './Details';

type FileUploadProps = {
  id: string;
  name: string;
  label?: string;
  detailsHeading?: string;
  detailsContent?: string;
};

function FileUpload(props: FileUploadProps) {
  const { id, name, label, detailsHeading, detailsContent } = props;
  const { getFieldState } = useFormContext();
  const { error } = getFieldState(name);

  return (
    <>
      {error && <ErrorMessage error={error} />}
      {detailsHeading && <Details heading={detailsHeading} content={detailsContent} />}

      <div className="govuk-form-group">
        {label && (
          <label className="govuk-heading-m" htmlFor={id}>
            {label}
          </label>
        )}

        <input
          id={id}
          name={name}
          className="govuk-file-upload"
          type="file"
          data-testid="file-upload"
          accept="image/*,.pdf"
          style={{ marginTop: '15px' }}
        />
      </div>
    </>
  );
}

FileUpload.displayName = 'FileUpload';

export default FileUpload;
